module.exports = __webpack_public_path__ + "static/media/logo.206cc073.png";